__webpack_public_path__ = window.remoteUrl;
const {
  setShellEventOrRun,
} = require('src/frontend/helper/general/setShellEvent');

require('optimize-suite/build/optimize-suite');

const { documentReady, windowLoaded } = require('@grpn/document-states');

function isObject(x) {
  return (
    typeof x === 'object' &&
    Object.prototype.toString.call(x) !== '[object Array]' &&
    x !== null
  );
}

function deepmerge(a, b) {
  Object.keys(b).forEach(key => {
    const value = b[key];
    if (b.hasOwnProperty(key)) {
      if (a[key] && value && isObject(a[key]) && isObject(value)) {
        deepmerge(a[key], value);
      } else {
        a[key] = value;
      }
    }
  });
}

function assembleConfig(conf, appConfig) {
  const {
    appName,
    channel,
    cookieDomain,
    pageType,
    optimizeOverwrite,
    platform,
    layoutConfig,
  } = conf;
  appConfig = appConfig || conf.appConfig;

  const { suiteData } = layoutConfig;
  const { config } = suiteData;

  deepmerge(config, appConfig);

  if (optimizeOverwrite) {
    deepmerge(config, optimizeOverwrite);
  }
  const { page } = config;

  suiteData.pageType = page.type = pageType || page.type;
  suiteData.channel = page.channel = channel || page.channel;

  suiteData.cookieDomain =
    config.cookieDomain != null
      ? config.cookieDomain
      : (config.cookieDomain = cookieDomain);
  suiteData.app = page.app != null ? page.app : (page.app = appName);

  // NOT sure why this is necessary ??!?!?!?!
  if (platform === 'touch') {
    suiteData.config.user = suiteData.config.user || {};
    suiteData.config.user.platform = platform;
  }
  Object.assign(window.Optimize, layoutConfig);
}

function runOptimizeSuite() {
  const { Optimize } = window;
  const { config } = Optimize.suiteData;
  config.finch = { config: Optimize.finchConfig };
  Optimize.config = config;
  OptimizeSuite.init(config);

  documentReady.then(() => {
    if (!Optimize.delayBloodhound) {
      OptimizeSuite.initBloodhound();
    }
  });

  windowLoaded.then(() =>
    setTimeout(() => {
      if (Optimize.delayBloodhound) {
        OptimizeSuite.initBloodhound();
      }
    }, 0)
  );

  if (config.devMode) {
    import('optimize-suite/build/optimize-suite-lazyloaded').then(() => {
      window.OptimizeSuite.initLazyLoaded(config);
    });
  }
}

// init finch just with that config so LS and ITA code doesn't fail on Finch.experiment
window.shellLayout &&
  window.Finch.initialize(window, window.Optimize.finchConfig);

setShellEventOrRun(
  'ls-optimize',
  () => runOptimizeSuite(assembleConfig(window.Optimize)),
  () => !window.Optimize.appConfig
);
